import { LoggerContext } from "context/LoggerContext";
import React, { useContext, useMemo } from "react";

const Slider = ({ slides }) => {
	const { logDebug } = useContext(LoggerContext);
	logDebug("slides", slides);
	// Generiere eine zufällige ID nur einmal beim Rendern
	const randomId = useMemo(() => `carousel-${Math.random().toString(36).substring(2, 11)}`, []);

	return (
		<>
			<div
				id={randomId}
				className="carousel slide"
				data-bs-ride="carousel">
				<div className="carousel-indicators">
					{slides &&
						slides.map((_, index) => (
							<button
								key={index}
								type="button"
								data-bs-target={`#${randomId}`}
								data-bs-slide-to={index}
								className={index === 0 ? "active" : ""}
								aria-current={index === 0 ? "true" : ""}
								aria-label={`Slide ${index + 1}`}></button>
						))}
				</div>
				<div className="carousel-inner">
					{slides &&
						slides.map((slide, index) => (
							<div
								key={slide.id || index}
								className={`carousel-item ${index === 0 ? "active" : ""} ratio ratio-16x9`}>
								<img
									src={slide.mediaUrl}
									className="d-block w-100 object-fit-cover"
									alt={slide.title}
								/>
								<div className="carousel-caption d-none d-md-block">
									<h5>{slide.title}</h5>
									<p>{slide.desc}</p>
								</div>
							</div>
						))}
				</div>
				<button
					type="button"
					id={`${randomId}-prev-btn`}
					data-bs-target={`#${randomId}`} // Dynamische ID
					data-bs-slide="prev"
						aria-label="Vorheriger Slide"> {/* Direktes aria-label statt aria-labelledby */}
					<span className="carousel-control-prev-icon" aria-hidden="true"></span>
					{/* Optional: zusätzlicher visuell versteckter Text */}
					<span className="visually-hidden">Vorheriger Slide</span>
				</button>
				<button
					type="button"
					id={`${randomId}-next-btn`}
					data-bs-target={`#${randomId}`} // Dynamische ID
					data-bs-slide="next"
						aria-label="Nächster Slide"> {/* Direktes aria-label statt aria-labelledby */}
					<span className="carousel-control-next-icon" aria-hidden="true"></span>
					{/* Optional: zusätzlicher visuell versteckter Text */}
					<span className="visually-hidden">Nächster Slide</span>
				</button>
			</div>
		</>
	);
};

export default Slider;
